<template>
  <h2
    class="text-body-1 mb-3"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </h2>
</template>

<script>
  export default {
    name: 'z-cabecalho',

    inheritAttrs: false
  }
</script>
